// v0.4.7+: forum src 2.0 化 (辉哥 2026-07-20 21:38 拍板, 砍 1.8 兼容)
//   - `import app from 'flarum/app'` → `import app from 'flarum/common/app'`
//     (2.0 vendor 走 flarum-webpack-config externals alias 解析成
//     `flarum.core.compat['app']' 字符串, 2.0 vendor 设了兼容)
//   - IndexPage 保持 `flarum/forum/components/IndexPage` (2.0 vendor 实际 namespace,
//     vendor dist 走 `flarum.core.compat['forum/components/IndexPage']`)
import app from 'flarum/common/app';
import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import Button from 'flarum/common/components/Button';
import SeedreamPage from './components/SeedreamPage';
import SeedreamHistoryPage from './components/SeedreamHistoryPage';
import EquipmentPage from './components/EquipmentPage';
import attachMenu from './attachMenu';
app.initializers.add('ziiven-dress-up', function () {
  // 注册 routes
  app.routes.dressUp = {
    path: '/dressUp',
    component: SeedreamPage
  };
  app.routes.dressUpHistory = {
    path: '/dressUp/history',
    component: SeedreamHistoryPage
  };

  // v0.4.0 Phase 2 批 2C-2: 装备库整页 (EquipmentPage)
  app.routes.equipment = {
    path: '/equipment',
    component: EquipmentPage
  };

  // Add sidebar link
  attachMenu();
});
export default {
  initialize: function () {
    // Forum module initialization
  }
};